import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";

import styles from "./Loader.scss";

export default function Loader({ inline = false }) {
  return (
    <CircularProgress
      disableShrink
      className={inline ? styles.loadingInline : styles.loadingContainer}
    />
  );
}
